module.exports = __webpack_public_path__ + "static/media/services_assistance_auto.1a7496d2.svg";